import { motion } from "motion/react";
import type { ReactNode } from "react";

interface Rotate180degAnimationProps {
	children: ReactNode;
	hasChanged: boolean;
}

export const Rotate180degAnimation = ({
	children,
	hasChanged,
}: Rotate180degAnimationProps) => {
	return (
		<motion.div
			animate={{ rotate: hasChanged ? 180 : 0 }}
			transition={{ duration: 0.3 }}
		>
			{children}
		</motion.div>
	);
};
